
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-adh-bigquery",
      function () {
        return require("private-next-pages/destinations/google-adh-bigquery.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-adh-bigquery"])
      });
    }
  